import * as betprofessor from './GetVerified.styles.betprofessor';
import * as betroyale from './GetVerified.styles.betroyale';
import * as fiestabet from './GetVerified.styles.fiestabet';
import * as goldenrush from './GetVerified.styles.goldenrush';
import * as juicybet from './GetVerified.styles.juicybet';
import * as puntcity from './GetVerified.styles.puntcity';
import * as puntgenie from './GetVerified.styles.puntgenie';
import * as questbet from './GetVerified.styles.questbet';
import * as sterlingparker from './GetVerified.styles.sterlingparker';
import * as vikingbet from './GetVerified.styles.vikingbet';
import * as volcanobet from './GetVerified.styles.volcanobet';
import * as wellbet from './GetVerified.styles.wellbet';
import * as forsport from './GetVerified.styles.forsport';
import * as junglebet from './GetVerified.styles.junglebet';
import * as betgalaxy from './GetVerified.styles.betgalaxy';
import * as buffalobet from './GetVerified.styles.buffalobet';
import * as titanbet from './GetVerified.styles.titanbet';
import * as slambet from './GetVerified.styles.slambet';
import * as gigabet from './GetVerified.styles.gigabet';
import * as betstride from './GetVerified.styles.betstride';
import * as bet777 from './GetVerified.styles.bet777';
import * as chromabet from './GetVerified.styles.chromabet';
import * as bet575 from './GetVerified.styles.bet575';
import * as epicodds from './GetVerified.styles.epicodds';
import * as pyramidbet from './GetVerified.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
};
